const abroadResources = {
  en: {
    abroad: {
      title: 'Travel insurance',
      calculator: 'Insurance Calculator',
      programs: 'Programs',
      territory: 'Choose a territory',
      summ: 'Sum insured',
      people: 'Number of insured',
      begin: 'Period from',
      end: 'Period from',
      covid: 'COVID-19 risk',
      premium: 'Premium',
      premiumPromotion: 'Discounted premium',
      button: 'Calculate',
      'button.next': 'Next',
      description: 'Description',
      subtitle:
        'Vacation is a long-awaited event, for which people get ready in advance carefully planning each day of rest. Before you start travelling, take out a medical insurance, which will become a reliable companion in an overseas trip. After all, even if you have thought out your vacation to the last detail, unfamiliar climate and exotic food can disrupt plans for a carefree holiday. The policy will cover the costs in case of injuries and emergency illnesses. Travel with travel insurance without stress, fully immersing yourself in new experiences.',
      period: 'Insurance period',
      stepper1: 'Cost calculation',
      stepper2: 'Data entry',
      stepper3: 'Registration of the policy',
      'acc1.title': 'Advantages',
      'acc1.html': `<ul style="margin: 0">
  <li>Low price</li>
  <li>Financial support in emergencies</li>
  <li>Round-the-clock medical assistance worldwide</li>
  <li>To obtain a visa</li>
  <li>Including the risk of COVID-19 does not affect the cost of the policy</li>
  <li>To be issued online</li>
</ul>`,
      'acc2.title': 'What is covered by the policy',
      'acc2.html': `<ul style="margin: 0">
  <li>Emergency medical care</li>
  <li>Outpatient and inpatient treatment</li>
  <li>Medication as prescribed by a physician</li>
  <li>Emergency dental care</li>
  <li>Medical home repatriation</li>
</ul>`,
      'acc3.title': 'What should be done in case of an insured event',
      'acc3.html': `<p style="margin: 0">
  The insurance policy specifies the contact phone numbers of Balt Assistance Ltd. assistant company, which is a foreign
  partner of Alatau City Garant. You should call these phone numbers, give your surname, first name and patronymic, tell your
  insurance policy number and describe a problem. If it is an insured event, an assistant company will direct you to the
  nearest medical institution with which it has an agreement and will explain further actions until help is provided.
</p>`,
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/web_light_rus_mst_23.07.2025.webp',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/mobile_light_rus_mst_23.07.2025.webp',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/web_dark_rus_mst_23.07.2025.webp',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/mobile_dark_rus_mst_23.07.2025.webp',
      },
      promotionDescription:
        'Alatau City Garant gives "Spring discounts" on travel insurance. Every customer who has issued a policy from February 25 to May 31, 2025, becomes a participant in the promotion.',
      promotionButton: 'Detailed terms of the promotion',
      promotionLink:
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/%D0%9F%D1%80%D0%B0%D0%B2%D0%B8%D0%BB%D0%B0%20%D0%B0%D0%BA%D1%86%D0%B8%D0%B8%20%D0%BF%D0%BE%20%D0%9C%D0%A1%D0%A2.pdf',
      'Введите номер телефона': 'Введите номер телефона',
      'Добавить страхователя': 'Добавить страхователя',
      ИИН: 'ИИН',
      Страхователь: 'Страхователь',
      'Страхователь / Застрахованный': 'Страхователь / Застрахованный',
      'Он же застрахованный': 'Он же застрахованный',
      'Добавить застрахованного': 'Добавить застрахованного',
      'Добавить страхователя и застрахованных':
        'Добавить страхователя и застрахованных',
      Застрахованные: 'Застрахованные',
      'Страхование выезжающих за рубеж': 'Страхование выезжающих за рубеж',
      Программа: 'Программа',
      'Количество застрахованных': 'Количество застрахованных',
      'Сумма покрытия': 'Сумма покрытия',
      'Дата начала договора': 'Дата начала договора',
      'Дата завершения договора': 'Дата завершения договора',
      Премия: 'Премия',
      Страны: 'Страны',
      Оплатить: 'Оплатить',
      'Нельзя добавить одного и того же застрахованного дважды':
        'Нельзя добавить одного и того же застрахованного дважды',
      'Максимальное количество застрахованных 5':
        'Максимальное количество застрахованных 5',
      'Данные успешно добавлены!': 'Данные успешно добавлены!',
      'Введите паспортные данные:': 'Введите паспортные данные:',
      'Введите данные:': 'Введите данные:',
      'Выберите тип документа': 'Выберите тип документа',
      'Удостоверение личности': 'Удостоверение личности',
      'Паспорт гражданина РК': 'Паспорт гражданина РК',
      'Свидетельство о рождении': 'Свидетельство о рождении',
      'Вид на жительство': 'Вид на жительство',
      'Удостоверение лица без гражданства':
        'Удостоверение лица без гражданства',
      'Заграничный паспорт': 'Заграничный паспорт',
      'Введите номер': 'Введите номер',
      'Неверный формат даты': 'Неверный формат даты',
      'Отсутствуют данные паспорта клиента в БД. Пожалуйста заполните данные удостоверения':
        'Отсутствуют данные паспорта клиента в БД. Пожалуйста заполните данные удостоверения',
      'Отсутствуют данные паспорта клиента в БД. Пожалуйста заполните паспортные данные':
        'Отсутствуют данные паспорта клиента в БД. Пожалуйста заполните паспортные данные',
      'Введите букву и номер ': 'Введите букву и номер',
      'Выберите дату выдачи ДД.ММ.ГГГГ': 'Выберите дату выдачи ДД.ММ.ГГГГ',
      'Введите имя на латинице': 'Введите имя на латинице',
      'Введите фамилию на латинице': 'Введите фамилию на латинице',
      Сохранить: 'Сохранить',
      'Номер телефона': 'Номер телефона',
      Выгодоприобретатель: 'Выгодоприобретатель',
      'ИИН Выгодоприобретателя': 'ИИН Выгодоприобретателя',
      'Добавление документа': 'Добавление документа',
      Застрахованный: 'Застрахованный',
      'Все программы доступны при обращении в офис нашей компании':
        'Все программы доступны при обращении в офис нашей компании',
      'Нельзя выбирать страны с разными валютами':
        'Нельзя выбирать страны с разными валютами',
      'Можно выбрать максимум до 5 стран': 'Можно выбрать максимум до 5 стран',
      Поиск: 'Поиск',
      'Проверка родственных связей': 'Проверка родственных связей',
      'Пожалуйста, введите ИИН родителя ребенка для проверки родственных связей':
        'Пожалуйста, введите ИИН родителя ребенка для проверки родственных связей',
    },
  },
  kz: {
    abroad: {
      title: 'Шетелге шығушыларды сақтандыру',
      calculator: 'Сақтандыру калькуляторы',
      programs: 'Бағдарламалар',
      territory: 'Аумақты таңдаңыз',
      summ: 'Сақтандыру сомасы',
      people: 'Сақтандырылғандар саны',
      begin: 'Кезең ... бастап',
      end: 'Кезең ... дейін',
      covid: 'COVID-19 тәуекел',
      premium: 'Сыйақы',
      premiumPromotion: 'Сыйақы жеңілдікпен',
      button: 'Есептеу',
      'button.next': 'Әрі қарай',
      description: 'Сипаттамасы',
      subtitle:
        'Демалыс - оған алдын-ала дайындалып, әр демалыс күні мұқият жоспарланатын, көп күттіретін оқиға. Саяхат басталмас бұрын медициналық сақтандыруды рәсімдеңіз, ол шетелге сапар шегу кезінде сенімді серігіңіз болады. Ақыр соңында, Сіз демалысты ұсақ-түйегіне дейін ойластырған болсаңыз да, бейтаныс климат пен экзотикалық тағам демалыс жоспарларыңызды жеңіл-желпі бұзуы мүмкін. Полис жарақаттар мен төтенше жағдайлар шығындарын жабады. Жаңа әсерлерге толығымен еніп, күйзеліссіз туристік сақтандырумен бірге саяхаттаңыз.',
      period: 'Сақтандыру кезеңі',
      stepper1: 'Бағасын есептеу',
      stepper2: 'Деректерді енгізу',
      stepper3: 'Полисті рәсімдеу',
      'acc1.title': 'Артықшылықтары',
      'acc1.html': `<ul style="margin: 0;">
  <li>Төмен бағасы</li>
  <li>Төтенше жағдайларда қаржылық қолдау</li>
  <li>Бүкіл әлем бойынша тәулік бойы медициналық көмек</li>
  <li>Виза алу үшін</li>
  <li>COVID-19 тәуекелі полистің құнына әсер етпейді</li>
  <li>Онлайн рәсімдеу</li>
</ul>`,
      'acc2.title': 'Сақтандыру нені қамтиды',
      'acc2.html': `<ul style="margin: 0;"></ul>
<li>Шұғыл медициналық көмекті</li>
<li>Амбулаториялық және стационарлық емдеуді</li>
<li>Дәрігердің нұсқауы бойынша дәрі-дәрмектерді</li>
<li>Шұғыл стоматологияны</li>
<li>Үйге медициналық репатриациялауды</li>
</ul>`,
      'acc3.title': 'Сақтандыру жағдайында не істеу керек',
      'acc3.html': `<p style="margin: 0;">
  Сақтандыру полисінде Balt Assistance LTD компаниясының байланыс телефондары көрсетілген - бұл Alatau City Garant-тың
  шетелдік серіктесі. Осы телефондарға қоңырау шалып, тегіңізді, атыңызды және әкеңіздің атын, сақтандыру полисіңіздің
  нөмірін және мәселенің мәнін айтуыңыз керек. Егер бұл сақтандыру жағдайы болса, ассистанс Сізді онымен шарт жасасқан
  жақын жердегі медициналық мекемеге жібереді және көмек көрсетілгенге дейін әрі қарайғы әрекеттерді түсіндіреді.
</p>`,
      premiumDescription:
        'Әлемнің кез келген жерінде тыныштық пен сенімділікті бағалайтын саяхатшыларға арналған премиум сақтандыру бағдарламасы. Полис шетелде кенеттен болатын аурулар немесе жазатайым оқиғалар кезінде жан-жақты медициналық қорғанысты қамтамасыз етеді. Емдеуді ұйымдастыруды, эвакуацияны және заң көмегін, сондай-ақ төтенше жағдайда отбасы мүшелерін қолдауды қамтиды.',
      'premium1.title': 'Артықшылықтары',
      'premium1.html': `<ul style="margin: 0;">
  <li>Барынша кең сақтандыру өтемі;</li>
  <li>Бүкіл әлем бойынша тәулік бойғы медициналық көмек;</li>
  <li>Дәрі-дәрмек және стоматологиялық шығындарды өтеу;</li>
  <li>Заңды және репатриациялық қолдау;</li>
  <li>Ауруханаға жатқызылған жағдайда туыстары мен балаларына көмек көрсету;</li>
  <li>Сақтандырылушылардың жасы - туғаннан бастап 80 жасқа дейін;</li>
  <li>Полисті ыңғайлы онлайн рәсімдеу.</li>
</ul>`,
      'premium2.title': 'Сақтандыру нені қамтиды',
      'premium2.html': `<ul style="margin: 0;"></ul>
<li>Шұғыл медициналық көмек және ауруханаға жатқызу;</li>
<li>Амбулаториялық және стационарлық емдеу;</li>
<li>Дәрігердің тағайындамасы бойынша дәрі-дәрмектер;</li>
<li>Шұғыл стоматология;</li>
<li>Медициналық эвакуация және мүрдені репатриациялау;</li>
<li>Ауруханаға жатқызу кезінде балаларды үйге қайтару;</li>
<li>Ұзақ уақыт ауруханаға жатқызу кезінде туысқандардың ұшып келуі;</li>
<li>Заңдық көмек.</li>
</ul>`,
      sportDescription:
        'Әуесқойлардан бастап кәсіпқойларға дейін - белсенді өмір салтын ұстанатындарға және спортпен шұғылданатындарға арналған арнайы сақтандыру бағдарламасы. Полис саяхатта немесе жарыстарда алған жарақаттар мен ауруларда қорғайды. ',
      'sport1.title': 'Артықшылықтары',
      'sport1.html': `<ul style="margin: 0;">
  <li>Спортшылар мен белсенді демалыс әуесқойларына арналған қорғаныс;</li>
  <li>Жаттығулар, жарыстар және басқа да спорттық іс-шаралар кезінде жарақаттарды өтеу;</li>
  <li>Төтенше жағдайларда медициналық көмек және эвакуация;</li>
  <li>Сақтандырылушылардың жасы - 5-55 жас;</li>
  <li>Полисті ыңғайлы онлайн рәсімдеу.</li>
</ul>`,
      'sport2.title': 'Сақтандыру нені қамтиды',
      'sport2.html': `<ul style="margin: 0;"></ul>
<li>Шұғыл медициналық көмек және ауруханаға жатқызу;</li>
<li>Амбулаториялық және стационарлық емдеу;</li>
<li>Дәрілік препараттар;</li>
<li>Шұғыл стоматология;</li>
<li>Медициналық эвакуация және тасымалдау;</li>
<li>Қайтыс болған жағдайда, мүрдені репатриациялау.</li>
</ul>`,
      studyWorkDescription:
        'Шетелге ұзақ мерзімге баратын студенттерге, тағылымдамадан өтушілерге және мамандарға арналған сақтандыру бағдарламасы. Полис медициналық шығындарды, емдеуді және жазатайым оқиғаларды эвакуациялауды өтей отырып, шетелде оқудың немесе жұмыстың барлық кезеңінде қорғанысты қамтамасыз етеді.',
      'studyWork1.title': 'Артықшылықтары',
      'studyWork1.html': `<ul style="margin: 0;">
  <li>Шетелдегі студенттер мен еңбек мигранттары үшін сенімді қорғаныс;</li>
  <li>Кеңейтілген медициналық өтем;</li>
  <li>Дәрі-дәрмек және стоматологиялық шығындарды өтеу;</li>
  <li>Медициналық эвакуация және репатриация;</li>
  <li>Ұзақ уақыт ауруханаға жатқызу кезінде туысқандарыңыздың ұшып келуіне ақы төлеу;</li>
  <li>Сақтандырылушылардың жасы - 7-50 жас;</li>
  <li>Полисті ыңғайлы онлайн рәсімдеу.</li>
</ul>`,
      'studyWork2.title': 'Сақтандыру нені қамтиды',
      'studyWork2.html': `<ul style="margin: 0;"></ul>
<li>Шұғыл медициналық көмек және емдеу;</li>
<li>Амбулаториялық және стационарлық емдеу;</li>
<li>Дәрігердің тағайындамасы бойынша дәрі-дәрмектер;</li>
<li>Шұғыл стоматология;</li>
<li>Медициналық эвакуация;</li>
<li>Мүрдені репатриациялау;</li>
<li>Ұзақ ауруханаға жатқызу кезінде туысының ұшып келуі.</li>
</ul>`,
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/web_light_kz_mst_23.07.2025.webp',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/mobile_light_kz_mst_23.07.2025.webp',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/web_dark_kz_mst_23.07.2025.webp',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/mobile_dark_kz_mst_23.07.2025.webp',
      },
      promotionDescription:
        'Alatau City Garant туристік сақтандыруға "Көктемгі жеңілдіктерді" ұсынады. 2025 жылғы 25 ақпаннан 31 мамырға дейін полисті ресімдеген әрбір клиент науқанға қатысушы болады.',
      promotionButton: 'Науқанның толық талаптары',
      promotionLink:
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/%D0%9F%D1%80%D0%B0%D0%B2%D0%B8%D0%BB%D0%B0%20%D0%B0%D0%BA%D1%86%D0%B8%D0%B8%20%D0%BF%D0%BE%20%D0%9C%D0%A1%D0%A2%20-%20%D0%BA%D0%B0%D0%B7.pdf',
      'Введите номер телефона': 'Телефон нөмірін енгізіңіз',
      'Добавить страхователя': 'Сақтанушыны қосу',
      ИИН: 'ЖСН',
      Страхователь: 'Сақтанушы',
      'Страхователь / Застрахованный': 'Сақтанушы / Сақтандырылған',
      'Он же застрахованный': 'Ол сақтандырылған тұлға болып табылады',
      'Добавить застрахованного': 'Сақтандырылған тұлғаны қосу',
      'Добавить страхователя и застрахованных':
        'Сақтанушы мен сақтандырылғандарды қосу',
      Застрахованные: 'Сақтандырылғандар',
      'Страхование выезжающих за рубеж': 'Шетелге шығушыларды сақтандыру',
      Программа: 'Бағдарлама',
      'Количество застрахованных': 'Сақтандырылған адамдар саны',
      'Сумма покрытия': 'Сақтандыру сомасы',
      'Дата начала договора': 'Шарттың басталу күні',
      'Дата завершения договора': 'Шарттың аяқталу күні',
      Премия: 'Сақтандыру сыйақысы',
      Страны: 'Елдер',
      Оплатить: 'Төлеу',
      'Нельзя добавить одного и того же застрахованного дважды':
        'Бір сақтандырылған тұлғаны екі рет қосуға болмайды',
      'Максимальное количество застрахованных 5':
        'Сақтандырылғандар саны 5-тен аспауы керек',
      'Данные успешно добавлены!': 'Деректер сәтті қосылды!',
      'Введите паспортные данные:': 'Паспорт деректерін енгізіңіз:',
      'Введите данные:': 'Деректерді енгізіңіз:',
      'Выберите тип документа': 'Құжат түрін таңдаңыз',
      'Удостоверение личности': 'Жеке куәлік',
      'Паспорт гражданина РК': 'Қазақстан Республикасының паспорты',
      'Свидетельство о рождении': 'Туу туралы куәлік',
      'Вид на жительство': 'Тұруға рұқсат',
      'Удостоверение лица без гражданства': 'Граждандығы жоқ адамның куәлігі',
      'Заграничный паспорт': 'Шетелдік паспорт',
      'Введите номер': 'Нөмірді енгізіңіз',
      'Неверный формат даты': 'Күні дұрыс емес форматта',
      'Отсутствуют данные паспорта клиента в БД. Пожалуйста заполните данные удостоверения':
        'Клиенттің паспорт деректері БД-да жоқ. Өтінеміз, куәлік деректерін толтырыңыз',
      'Отсутствуют данные паспорта клиента в БД. Пожалуйста заполните паспортные данные':
        'Клиенттің төлқұжат деректері деректер базасында жоқ. Өтінеміз, төлқұжат мәліметтерін толтырыңыз',
      'Введите букву и номер': 'Әріп пен нөмірді енгізіңіз',
      'Выберите дату выдачи ДД.ММ.ГГГГ': 'Берілген күнді таңдаңыз КК.АА.ЖЖЖЖ',
      'Введите имя на латинице': 'Атын латын әріптерімен енгізіңіз',
      'Введите фамилию на латинице': 'Тегін латын әріптерімен енгізіңіз',
      Сохранить: 'Сақтау',
      'Номер телефона': 'Телефон нөмірі',
      Выгодоприобретатель: 'Пайда алушы',
      'ИИН Выгодоприобретателя': 'Пайда алушының ЖСН',
      'Добавление документа': 'Құжатты қосу',
      Застрахованный: 'Сақтандырылған',
      'Все программы доступны при обращении в офис нашей компании':
        'Барлық бағдарламалар біздің компаниямыздың кеңсесіне жүгінген кезде қолжетімді',
      'Нельзя выбирать страны с разными валютами':
        'Әртүрлі валюталары бар елдерді таңдау мүмкін емес',
      'Можно выбрать максимум до 5 стран': '5 елден артық таңдау мүмкін емес',
      Поиск: 'Іздеу',
      'Проверка родственных связей': 'Туысқандық байланыстарды тексеру',
      'Пожалуйста, введите ИИН родителя ребенка для проверки родственных связей':
        'Туысқандық байланыстарды тексеру үшін баланың ата-анасының ЖСН-н енгізіңіз',
    },
  },
  ru: {
    abroad: {
      title: 'Страхование выезжающих за рубеж',
      calculator: 'Калькулятор страхования',
      programs: 'Программы',
      territory: 'Выберите территорию',
      summ: 'Страховая сумма',
      people: 'Количество застрахованных',
      begin: 'Период с',
      end: 'Период по',
      covid: 'COVID-19 риск',
      premium: 'Премия',
      premiumPromotion: 'Премия со скидкой',
      button: 'Рассчитать',
      'button.next': 'Далее',
      description: 'Описание',
      subtitle:
        'Отпуск – долгожданное событие, к которому готовятся заранее, тщательно планируя каждый день отдыха. До начала путешествия оформите медицинскую страховку, которая станет надежным спутником в заграничной поездке. Ведь даже если вы продумали отпуск до мелочей, незнакомый климат и экзотическая еда могут нарушить планы на беззаботный отдых. Полис покроет расходы при травмах и экстренных заболеваниях. Путешествуйте с туристической страховкой без стресса, полностью погружаясь в новые впечатления.',
      period: 'Период страхования',
      stepper1: 'Расчет стоимости',
      stepper2: 'Ввод данных',
      stepper3: 'Оформление полиса',
      'acc1.title': 'Преимущества',
      'acc1.html': `<ul style="margin: 0">
  <li>Низкая цена</li>
  <li>Финансовая поддержка в экстренных ситуациях</li>
  <li>Круглосуточная медицинская помощь по всему миру</li>
  <li>Для получения визы</li>
  <li>Включение риска COVID-19 не влияет на стоимость полиса</li>
  <li>Оформление онлайн</li>
</ul>`,
      'acc2.title': 'Что покрывает страховка',
      'acc2.html': `<ul style="margin: 0">
  <li>Экстренная медицинская помощь</li>
  <li>Амбулаторное и стационарное лечение</li>
  <li>Лекарства по назначению врача</li>
  <li>Экстренная стоматология</li>
  <li>Медицинская репатриация домой</li>
</ul>`,
      'acc3.title': 'Что делать при страховом случае',
      'acc3.html': `<p style="margin: 0">
  В страховом полисе указаны контактные телефоны ассистанской компании Balt Assistance Ltd. – это зарубежный партнер
  Alatau City Garant. Необходимо позвонить по этим телефонам, назвать свою фамилию, имя и отчество, номер страхового полиса и
  суть проблемы. Если это страховой случай, ассистанс направит вас в ближайшее медицинское учреждение, с которым у него
  есть договор и разъяснит дальнейшие действия до тех пор, пока помощь не будет оказана.
</p>`,
      premiumDescription:
        'Премиальная программа страхования для путешественников, ценящих спокойствие и уверенность в любой точке мира. Полис обеспечивает всестороннюю медицинскую защиту при внезапных заболеваниях или несчастных случаях за рубежом. Включает организацию лечения, эвакуацию и юридическую помощь, а также поддержку членов семьи в экстренных ситуациях.',
      'premium1.title': 'Преимущества',
      'premium1.html': `<ul style="margin: 0">
  <li>Максимально широкое страховое покрытие;</li>
  <li>Круглосуточная медицинская помощь по всему миру;</li>
  <li>Компенсация расходов на лекарства и стоматологию;</li>
  <li>Юридическая и репатриационная поддержка;</li>
  <li>Помощь родственникам и детям в случае вашей госпитализации;</li>
  <li>Возраст застрахованных - от рождения до 80 лет;</li>
  <li>Удобное онлайн-оформление полиса.</li>
</ul>`,
      'premium2.title': 'Что покрывает страховка',
      'premium2.html': `<ul style="margin: 0">
  <li>Экстренная медицинская помощь и госпитализация;</li>
  <li>Амбулаторное и стационарное лечение;</li>
  <li>Лекарства по назначению врача;</li>
  <li>Экстренная стоматология;</li>
  <li>Медицинская эвакуация и репатриация тела;</li>
  <li>Возврат детей домой при вашей госпитализации;</li>
  <li>Перелет родственника при вашей длительной госпитализации;</li>
  <li>Юридическая помощь.</li>
</ul>`,
      sportDescription:
        'Специальная программа страхования для тех, кто ведет активный образ жизни и занимается спортом - от любителей до профессионалов. Полис защищает при травмах и заболеваниях, полученных в путешествии или на соревнованиях.',
      'sport1.title': 'Преимущества',
      'sport1.html': `<ul style="margin: 0">
  <li>Защита для спортсменов и любителей активного отдыха;</li>
  <li>Покрытие травм во время тренировок, соревнований и иных спортивных мероприятий;</li>
  <li>Медицинская помощь и эвакуация в экстренных случаях;</li>
  <li>Возраст застрахованных - 5-55 лет;</li>
  <li>Удобное онлайн-оформление полиса.</li>
</ul>`,
      'sport2.title': 'Что покрывает страховка',
      'sport2.html': `<ul style="margin: 0">
  <li>Экстренная медицинская помощь и госпитализация;</li>
  <li>Амбулаторное и стационарное лечение;</li>
  <li>Лекарственные препараты;</li>
  <li>Экстренная стоматология;</li>
  <li>Медицинская эвакуация и транспортировка;</li>
  <li>Репатриация тела в случае смерти.</li>
</ul>`,
      studyWorkDescription:
        'Программа страхования для студентов, стажеров и специалистов, выезжающих за рубеж на длительный срок. Полис обеспечивает защиту на весь период обучения или работы за границей, покрывая медицинские расходы, лечение и эвакуацию при несчастных случаях. ',
      'studyWork1.title': 'Преимущества',
      'studyWork1.html': `<ul style="margin: 0">
  <li>Надёжная защита для студентов и трудовых мигрантов за рубежом;</li>
  <li>Расширенное медицинское покрытие;</li>
  <li>Компенсация расходов на лекарства и стоматологию;</li>
  <li>Медицинская эвакуация и репатриация;</li>
  <li>Оплата перелета родственника при вашей длительной госпитализации;</li>
  <li>Возраст застрахованных - 7-50 лет;</li>
  <li>Удобное онлайн-оформление полиса.</li>
</ul>`,
      'studyWork2.title': 'Что покрывает страховка',
      'studyWork2.html': `<ul style="margin: 0">
  <li>Экстренная медицинская помощь и лечение;</li>
  <li>Амбулаторное и стационарное лечение;</li>
  <li>Лекарства по назначению врача;</li>
  <li>Экстренная стоматология;</li>
  <li>Медицинская эвакуация;</li>
  <li>Репатриация тела;</li>
  <li>Перелет родственника при длительной госпитализации.</li>
</ul>`,
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/web_light_rus_mst_23.07.2025.webp',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/mobile_light_rus_mst_23.07.2025.webp',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/web_dark_rus_mst_23.07.2025.webp',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/mobile_dark_rus_mst_23.07.2025.webp',
      },
      promotionDescription:
        'Alatau City Garant дарит "Весенние скидки" на туристическую страховку. Участником акции становится каждый клиент, оформивший полис с 25 февраля по 31 мая 2025 года.',
      promotionButton: 'Подробные условия акции',
      promotionLink:
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/%D0%9F%D1%80%D0%B0%D0%B2%D0%B8%D0%BB%D0%B0%20%D0%B0%D0%BA%D1%86%D0%B8%D0%B8%20%D0%BF%D0%BE%20%D0%9C%D0%A1%D0%A2.pdf',
      'Введите номер телефона': 'Введите номер телефона',
      'Добавить страхователя': 'Добавить страхователя',
      'Добавить страхователя и застрахованных':
        'Добавить страхователя и застрахованных',
      ИИН: 'ИИН',
      Страхователь: 'Страхователь',
      'Страхователь / Застрахованный': 'Страхователь / Застрахованный',
      'Он же застрахованный': 'Он же застрахованный',
      'Добавить застрахованного': 'Добавить застрахованного',
      Застрахованные: 'Застрахованные',
      'Страхование выезжающих за рубеж': 'Страхование выезжающих за рубеж',
      Программа: 'Программа',
      'Количество застрахованных': 'Количество застрахованных',
      'Сумма покрытия': 'Сумма покрытия',
      'Дата начала договора': 'Дата начала договора',
      'Дата завершения договора': 'Дата завершения договора',
      Премия: 'Премия',
      Страны: 'Страны',
      Оплатить: 'Оплатить',
      'Нельзя добавить одного и того же застрахованного дважды':
        'Нельзя добавить одного и того же застрахованного дважды',
      'Максимальное количество застрахованных 5':
        'Максимальное количество застрахованных 5',
      'Данные успешно добавлены!': 'Данные успешно добавлены!',
      'Введите паспортные данные:': 'Введите паспортные данные:',
      'Введите данные:': 'Введите данные:',
      'Выберите тип документа': 'Выберите тип документа',
      'Удостоверение личности': 'Удостоверение личности',
      'Паспорт гражданина РК': 'Паспорт гражданина РК',
      'Свидетельство о рождении': 'Свидетельство о рождении',
      'Вид на жительство': 'Вид на жительство',
      'Удостоверение лица без гражданства':
        'Удостоверение лица без гражданства',
      'Заграничный паспорт': 'Заграничный паспорт',
      'Введите номер': 'Введите номер',
      'Неверный формат даты': 'Неверный формат даты',
      'Отсутствуют данные паспорта клиента в БД. Пожалуйста заполните данные удостоверения':
        'Отсутствуют данные паспорта клиента в БД. Пожалуйста заполните данные удостоверения',
      'Отсутствуют данные паспорта клиента в БД. Пожалуйста заполните паспортные данные':
        'Отсутствуют данные паспорта клиента в БД. Пожалуйста заполните паспортные данные',
      'Введите букву и номер ': 'Введите букву и номер',
      'Выберите дату выдачи ДД.ММ.ГГГГ': 'Выберите дату выдачи ДД.ММ.ГГГГ',
      'Введите имя на латинице': 'Введите имя на латинице',
      'Введите фамилию на латинице': 'Введите фамилию на латинице',
      Сохранить: 'Сохранить',
      'Номер телефона': 'Номер телефона',
      Выгодоприобретатель: 'Выгодоприобретатель',
      'ИИН Выгодоприобретателя': 'ИИН Выгодоприобретателя',
      'Добавление документа': 'Добавление документа',
      Застрахованный: 'Застрахованный',
      'Все программы доступны при обращении в офис нашей компании':
        'Все программы доступны при обращении в офис нашей компании',
      'Нельзя выбирать страны с разными валютами':
        'Нельзя выбирать страны с разными валютами',
      'Можно выбрать максимум до 5 стран': 'Можно выбрать максимум до 5 стран',
      Поиск: 'Поиск',
      'Проверка родственных связей': 'Проверка родственных связей',
      'Пожалуйста, введите ИИН родителя ребенка для проверки родственных связей':
        'Пожалуйста, введите ИИН родителя ребенка для проверки родственных связей',
    },
  },
};

export default abroadResources;
